module.exports = __webpack_public_path__ + "img/with_love.0126e3d1.svg";